"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BatchBillingListEditor = class BatchBillingListEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItemFromSources(...args) {
        const [items, fields] = args;
        const fieldNames = _.map(fields, 'name');
        let result = {};
        _.each(items, (item, i) => {
            if (i === 0) {
                result = _.pick(item, fieldNames);
            }
            for (const { name, defaultValue } of fields) {
                if (result[name] != item[name]) {
                    result[name] = defaultValue;
                    continue;
                }
                if (_.isUndefined(result[name])) {
                    result[name] = defaultValue;
                    continue;
                }
                if (result[name] != null) {
                    result[name] = item[name];
                }
            }
        });
        result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {});
        return result;
    }
    getPayload(...args) {
        const [items, item] = args;
        const updates = _.keys(_.pickBy(item.$updates, _.identity));
        if (!updates.length) {
            return;
        }
        const update = _.pick(item, updates);
        return {
            items: _.map(items, p => ({
                id: p.id,
                etag: p.etag,
                value: update
            }))
        };
    }
    syncExchangeRate(...args) {
        const v = this.exchange_rate;
        this.item.exchange_rate = v.value == null ? null : v;
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    isReadonly;
    exchange_rate;
    async $$load_exchange_rate() {
        return { value: null, date: null, source: null };
    }
    exchangeRateSources;
    async $$load_exchangeRateSources() {
        return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' });
    }
    editableFields;
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.getItemFromSources(this.items, this.$data.editableFields);
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['isReadonly', 'exchange_rate', 'exchangeRateSources', 'editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                isReadonly: false,
                exchange_rate: null,
                exchangeRateSources: null,
                editableFields: [{
                        name: "fulfillment_date",
                    },
                    {
                        name: "due_date",
                    },
                    {
                        name: "currency",
                    },
                    {
                        name: "exchange_rate",
                    },
                    {
                        name: "billing_period",
                        defaultValue: {
                            start: null,
                            end: null,
                        },
                    },
                ],
                labelAlign: "right",
                formId: null,
                formName: "BatchBillingListEdit",
                item: null,
                currencies: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BatchBillingListEditor|Title", "Batch Edit Billint List Items"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2108_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_2114_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_2112_getActionArgs($event) {
        return {
            operation: "bulk_update_billing_list_item",
            data: this.getPayload(this.items, this.item),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_4397690859646801_script_2116_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_4397690859646801_script_2116_getActionArgs($event) {
        return {
            value: () => this.act_4397690859646801_script_2116_getActionArgs_value($event),
        };
    }
    async evh_4397690859646801_blur(event, scope) {
        return await this.actions.evh_4397690859646801_blur.executeFromDOM(this, event, scope);
    }
    async act_4067533979448964_script_2118_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_4067533979448964_script_2118_getActionArgs($event) {
        return {
            value: () => this.act_4067533979448964_script_2118_getActionArgs_value($event),
        };
    }
    async evh_4067533979448964_blur(event, scope) {
        return await this.actions.evh_4067533979448964_blur.executeFromDOM(this, event, scope);
    }
    async act_8826227742204642_script_2120_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_8826227742204642_script_2120_getActionArgs($event) {
        return {
            value: () => this.act_8826227742204642_script_2120_getActionArgs_value($event),
        };
    }
    async evh_8826227742204642_blur(event, scope) {
        return await this.actions.evh_8826227742204642_blur.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2108 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2108_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2107 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2108,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2107],
        });
        const act_2248226175642056_closeComponent_2110 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2109 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2110,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2109],
        });
        const act_1040167445267876_closeModal_2114 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_2114_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_2113 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_2114,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_2112 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_2112_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_2113],
        });
        const evh_1040167445267876_submit_2111 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_2112,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_2111],
        });
        const act_4397690859646801_script_2116 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4397690859646801_script_2116_getActionArgs,
            events: [],
        });
        const evh_4397690859646801_blur_2115 = new core_1.actions.EventHandlerImpl({
            action: act_4397690859646801_script_2116,
            event: "blur",
            displayName: "script",
        });
        const evh_4397690859646801_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4397690859646801_blur_2115],
        });
        const act_4067533979448964_script_2118 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4067533979448964_script_2118_getActionArgs,
            events: [],
        });
        const evh_4067533979448964_blur_2117 = new core_1.actions.EventHandlerImpl({
            action: act_4067533979448964_script_2118,
            event: "blur",
            displayName: "script",
        });
        const evh_4067533979448964_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4067533979448964_blur_2117],
        });
        const act_8826227742204642_script_2120 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8826227742204642_script_2120_getActionArgs,
            events: [],
        });
        const evh_8826227742204642_blur_2119 = new core_1.actions.EventHandlerImpl({
            action: act_8826227742204642_script_2120,
            event: "blur",
            displayName: "script",
        });
        const evh_8826227742204642_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8826227742204642_blur_2119],
        });
        const act_1419464017721962_closeComponent_2122 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2121 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_2122,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2121],
        });
        return {
            act_7315092382398562_closeModal_2108,
            evh_7315092382398562_close_2107,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2110,
            evh_2248226175642056_close_2109,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_2114,
            evh_1040167445267876_success_2113,
            act_1040167445267876_request_2112,
            evh_1040167445267876_submit_2111,
            evh_1040167445267876_submit,
            act_4397690859646801_script_2116,
            evh_4397690859646801_blur_2115,
            evh_4397690859646801_blur,
            act_4067533979448964_script_2118,
            evh_4067533979448964_blur_2117,
            evh_4067533979448964_blur,
            act_8826227742204642_script_2120,
            evh_8826227742204642_blur_2119,
            evh_8826227742204642_blur,
            act_1419464017721962_closeComponent_2122,
            evh_1419464017721962_clickPreventStop_2121,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_2112,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BatchBillingListEditor.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BatchBillingListEditor.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BatchBillingListEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BatchBillingListEditor.prototype, "onSize", null);
BatchBillingListEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], BatchBillingListEditor);
exports.default = BatchBillingListEditor;
vue_property_decorator_1.Vue.component("BatchBillingListEditor", BatchBillingListEditor);
